// extracted by mini-css-extract-plugin
module.exports = {"abtn_box":"Abutton_abtn_box__2Fvu-","btn_diamond":"Abutton_btn_diamond__3I6c3","btn_bagcolor":"Abutton_btn_bagcolor__3zV1R"};